// portraits — deterministic assignment from the AI portrait pool
// (public/assets/portraits/). Players need no persisted field: gender comes
// from the first name, life stage from the age (the portrait "matures" as
// the player ages — a feature) and the variant from the id hash. Staff DO
// persist an avatarId so their face never shifts. PlayerAvatar's SVG
// fallback means everything works before/without the art.

import { FIRST_NAMES_FEMALE, type Player } from '@/config/playersConfig'
import { getPlayerStage } from '@/config/playerStageConfig'
import { hashString } from '@/game/utils/rng'

export const PORTRAIT_VARIANTS = 4

const FEMALE_NAMES = new Set(FIRST_NAMES_FEMALE)

export type PortraitGender = 'm' | 'f'

export function inferGender(name: string): PortraitGender {
  const first = name.trim().split(/\s+/)[0]
  return FEMALE_NAMES.has(first) ? 'f' : 'm'
}

/** /assets/portraits/player/{m|f}_{rising|peak|veteran}_{01..04}.webp */
export function playerPortraitSrc(player: Pick<Player, 'id' | 'name' | 'age'>): string {
  const gender = inferGender(player.name)
  const stage = getPlayerStage(player.age)
  const variant = (hashString(player.id) % PORTRAIT_VARIANTS) + 1
  return `/assets/portraits/player/${gender}_${stage}_${String(variant).padStart(2, '0')}.webp`
}

/** /assets/portraits/staff/{avatarId}.webp — avatarId persisted at hire */
export function staffPortraitSrc(avatarId: string): string {
  return `/assets/portraits/staff/${avatarId}.webp`
}
